<template>
  <div>
    <div class="">
      <span class="my-0 block block py-2 hover:text-white border-b transition ease-in-out duration-150 hoverable-menu"
            id="categories-menu" @click="show()">{{ $t('footer.menu_titles.categories') }}</span>
      <ul class="p-0  mt-2  h7 submenu" style="display: none" id="categories-drop-down">
        <li v-for="category in categories" @click="close()" :key="category.slug"
            class="text-hoverable list-unstyled py-0 my-0">
          <inertia-link :href="route('shop.category.view', category.slug)">
            <span v-if="category.name == 'Sales'" style="color:red" class="my-0 text-sm">{{ category.name }}</span>
            <span v-else class="my-0 text-sm">{{ category.name }}</span>
          </inertia-link>
          <ul v-if="category.mapped">
            <li v-for="mapped in category.mapped" :key="mapped.slug">
              <inertia-link :href="route('shop.category.view', [category.slug, mapped.slug])">
                <span class="ml-6" style="font-size: 0.7rem !important;line-height: 0"><i>- {{ mapped.name }}</i></span>
              </inertia-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <inertia-link @click="close()"
                  class="block py-2 hover:bg-gray-800 hover:text-white border-b transition ease-in-out duration-150"
                  :href="route('shop.landing')" :data="{ anchor: 'highlights' }">
      {{ $t('menu.highlights') }}
    </inertia-link>
    <inertia-link @click="close()"
                  class="block py-2 hover:bg-gray-800 hover:text-white border-b transition ease-in-out duration-150"
                  :href="route('shop.howbuy.view')">
      {{ $t('menu.how_buy') }}
    </inertia-link>
    <inertia-link @click="close()"
                  class="block py-2 hover:bg-gray-800 hover:text-white border-b transition ease-in-out duration-150"
                  :href="route('shop.howsell.view')">
      {{ $t('menu.how_sell') }}
    </inertia-link>
    <inertia-link @click="close()"
                  class="block py-2 hover:bg-gray-800 hover:text-white border-b transition ease-in-out duration-150"
                  :href="route('shop.landing')" :data="{ anchor: 'contact' }">
      {{ $t('menu.contact') }}
    </inertia-link>
    <div class="h4 ml-0 border-top pt-1 px-2 row d-flex justify-content-center">
      <i v-for="entry in languages" :key="entry.title" class="sl-flag center-vertically mr-5 mt-8"
         v-bind:class="'flag-' + entry.language" @click="changeLocale(entry.language)"></i> <i
        class="fa fa-angle-down" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    categories: Object,
  },
  data() {
    return {
      languages: [
        {
          flag: 'us', language: 'en', title: 'English'
        },
        {
          flag: 'ro', language: 'ro', title: 'Română'
        }
      ],
    }
  },
  methods: {
    isRo() {
      return window.location.pathname.split('/')[1] === 'ro';
    },
    changeLocale(locale) {
      console.log(locale)
      // i18n.locale = locale;
      var currentLocale = window.location.pathname.split('/')[1];
      console.log(currentLocale)
      var theURL = window.location.pathname;
      theURL = theURL.replace(currentLocale, locale);
      console.log(theURL)
      window.location.replace(theURL);
    },
    currentLocale() {
      // i18n.locale = locale;
      return '/' + window.location.pathname.split('/')[1];
    },
    close() {
      this.$emit('close')
    },
    show: function () {
      const dropDown = document.getElementById('categories-drop-down');
      // const menu = document.getElementById('categories-drop-down');
      if (dropDown.style.display === "none") {
        dropDown.style.display = "block";
      } else {
        dropDown.style.display = "none";
      }
    }
  }
}
</script>
